<template>
  <div class="col-lg-12">
    <div class="main-card mb-3 card" style="margin: 20px">
      <div class="card-body">
        <h5 class="card-title">
          상품관리
          <!--<div class="sub_title">주문관리 → 상품관리</div>-->
        </h5>

        <query-grid :config="config" ref="qg">

          <template #items="props">

            <tr v-for="record in props.records" v-bind:key="record.id">
              <th scope="row">{{ record.id }}</th>
              <td>{{ record.buyPermission }}</td>
              <td>
                <productN :productN="record" :ref="'admusr' + record.id" />
              </td>
              <td>{{ record.product }}</td>
              <td>{{ record.period }}</td>
              <td>{{ parseInt(record.price).toLocaleString() }}원</td>
              <td>{{ parseInt(record.retail_margin).toLocaleString() }}원</td>
              <td>{{ record.bookclubs == 0 ? "미사용" : "사용" }}</td>
              <td>{{ record.vocajoa == 0 ? "미사용" : "사용" }}</td>
              <td>{{ record.subject == null ? 0 : record.subject}}</td>              
              <td>{{ record.active == 0 ? "미사용" : "사용" }}</td>
              <td style="width:30%;">{{ record.memo }}</td>
              <td>
                <button
                  class="btn btn-warning btn-sm"
                  @click="this.$refs['admusr' + record.id][0].openModal()"
                >
                  수정
                </button>
                <button
                  class="btn btn-danger btn-sm"
                  @click="deleteUser(record)"
                >
                  삭제
                </button>
              </td>
            </tr>
          </template>
          <template #actions>
            <button
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target=".new_product"
              @click="creatingMode()"
            >
              상품 등록
            </button>
          </template>
        </query-grid>

        <div
          class="modal fade new_product"
          tabindex="-1"
          role="dialog"
          id="ProModal"
          data-bs-target=".new_product"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">신규상품 등록/수정</div>
              <div class="modal-body">
                <table class="table">

                  <tbody>

                    <tr>
                      <th>상품코드</th>
                      <td style="text-align: center">자동생성</td>
                      <td>사용여부</td>
                      <td>
                        <select
                          class="hidtype"
                          :value="nvl(changedData.active, selData.active)"
                          :class="{ 'hidtype-changed': changedData.active }"
                          @input="doChange('active', $event.target.value)"
                        >
                          <option value="1">사용</option>
                          <option value="0">미사용</option>
                        </select>
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.active"
                          @click="delete changedData.active"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <th>상품명</th>
                      <td colspan="3">
                        <input
                          class="hidtype"
                          style="width: 90%"
                          :value="changedData.name || selData.name"
                          :class="{ 'hidtype-changed': changedData.name }"
                          @input="doChange('name', $event.target.value)"
                          placeholder="상품명"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.name"
                          @click="delete changedData.name"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <th>상품유형</th>
                      <td>
                        <select
                          class="hidtype"
                          :value="nvl(changedData.product, selData.product)"
                          :class="{ 'hidtype-changed': changedData.product }"
                          @input="doChange('product', $event.target.value)"
                        >
                          <option selected value="ChildU">ChildU</option>
                          <option value="MYPATH">MYPATH</option>
                          <option value="ChildUM">ChildU(M)</option>
                        </select>
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.product"
                          @click="dataDelete('product')"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                      <th>상품개월</th>
                      <td>
                        <select
                          class="hidtype"
                          :value="nvl(changedData.period, selData.period)"
                          :class="{ 'hidtype-changed': changedData.period }"
                          @input="doChange('period', $event.target.value)"
                        >
                          <option selected value="1">1개월</option>
                          <option value="2">2개월</option>
                          <option value="3">3개월</option>
                        </select>
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.period"
                          @click="delete changedData.period"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <th>판매가</th>
                      <td>
                        <input
                          class="hidtype"
                          :value="changedData.price || selData.price"
                          :class="{ 'hidtype-changed': changedData.price }"
                          @input="doChange('price', $event.target.value)"
                          placeholder="판매가"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.price"
                          @click="delete changedData.price"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i></button
                        >&nbsp;원
                      </td>
                      <th>판매수수료</th>
                      <td>
                        <input
                          class="hidtype"
                          :value="
                            changedData.retail_margin || selData.retail_margin
                          "
                          :class="{
                            'hidtype-changed': changedData.retail_margin,
                          }"
                          @input="
                            doChange('retail_margin', $event.target.value)
                          "
                          placeholder="판매수수료"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.retail_margin"
                          @click="delete changedData.retail_margin"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i></button
                        >&nbsp;원
                      </td>
                    </tr>
                    <tr>
                      <th>북클럽</th>
                      <td>
                        <select
                          class="hidtype"
                          :value="nvl(changedData.bookclubs, selData.bookclubs)"
                          :class="{ 'hidtype-changed': changedData.bookclubs }"
                          @input="doChange('bookclubs', $event.target.value)"
                        >
                          <option selected>선택</option>
                          <option value="1">사용</option>
                          <option value="0">미사용</option>
                        </select>
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.bookclubs"
                          @click="delete changedData.bookclubs"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                      <th>보카조아</th>
                      <td>
                        <select
                          class="hidtype"
                          :value="nvl(changedData.vocajoa, selData.vocajoa)"
                          :class="{ 'hidtype-changed': changedData.vocajoa }"
                          @input="doChange('vocajoa', $event.target.value)"
                        >
                          <option selected>선택</option>
                          <option value="1">사용</option>
                          <option value="0">미사용</option>
                        </select>
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.vocajoa"
                          @click="delete changedData.vocajoa"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <th>노출그룹</th>
                      <td>
                        <input
                          class="hidtype"
                          style="width: 90%"
                          :value="
                            changedData.buyPermission || selData.buyPermission
                          "
                          :class="{
                            'hidtype-changed': changedData.buyPermission,
                          }"
                          @input="
                            doChange('buyPermission', $event.target.value)
                          "
                          placeholder="노출그룹"
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.buyPermission"
                          @click="delete changedData.buyPermission"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                      <th><template v-if="this.childum_chk">과목수량</template></th>
                      <td><template v-if="this.childum_chk">
                        <select
                          class="hidtype"
                          :value="nvl(changedData.subject, selData.subject)"
                          :class="{ 'hidtype-changed': changedData.subject }"
                          @input="doChange('subject', $event.target.value)"
                        >
                          <option selected>선택</option>
                          <option value="1">1과목</option>
                          <option value="2">2과목</option>
                          <option value="3">3과목</option>
                          <option value="4">4과목</option>
                        </select>
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.subject"
                          @click="dataDelete('subject')"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button></template>
                      </td>
                    </tr>
                    <tr>
                      <th>메모</th>
                      <td colspan="3">
                        <input
                          class="hidtype"
                          :value="changedData.memo || selData.memo"
                          :class="{ 'hidtype-changed': changedData.memo }"
                          @input="doChange('memo', $event.target.value)"
                          style="width: 90%"
                          placeholder="상품에 특별한 내용이 있을경우에만 입력해주세요."
                        />
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.memo"
                          @click="delete changedData.memo"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="flex_center">
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="doSend()"
                  >
                    상품등록
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    닫기
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid";
import VueCookies from "vue-cookies";
import axios from "axios";
import TreeBtn from "../components/treeBtn.vue";
import productN from "../components/detail_pages/product.vue";
export default {
  name: "Home",
  components: {
    Tree,
    Business,
    TreeBtn,
    QueryGrid,
    productN,
  },
  mounted() {
    this.childum_chk = false;
    this.$refs.qg.search();
  },
  methods: {
    deleteUser(user) {
      if (!confirm("정말로 삭제할까요")) return;
      axios.delete("/products/" + user.id).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "삭제할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "삭제되었습니다.",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          this.childum_chk = false;
          this.$refs.qg.search();
        }
      });
    },
    doChange(name, value) {
      if (this.selData[name] === value) {
        delete this.changedData[name];
      } else {
        this.changedData[name] = value;
      }

      if( name === "product"){
        this.changedData['subject'] = "";
        if ( value === "ChildUM" ) {       
        this.childum_chk = true;        
        }else {
        this.childum_chk = false;
        }
      }

    },
    dataDelete(name){
      
      if(name==="product"){
        delete this.changedData[name];
        this.childum_chk = false;  
      }else{
        this.changedData[name] = "";
      }
    }
    ,
    doSend() {
      // 업데이트일 경우 patch /businesses/번호
      // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
      
      if(this.changedData.product === "ChildUM"){
        if(this.changedData.subject === ""){
          alert("과목수량을 선택해주세요.");
          return;
        }
      }
     
      var data = {};
      if (this.creating) {
        data = {
          ...this.selData,
          ...this.changedData,
        };
      } else {
        data = this.changedData;
      }

      var send = {
        method: this.creating ? "post" : "patch",
        url: "/product_manage" + (!this.creating ? "/" + this.selData.id : ""),
        data: data,
      };

      //console.log(data.active);
      //return;

      if (!data.active) {
        $.notify(
          {
            // options
            message: "사용유무를 지정하셔야 합니다. ",
          },
          {
            // settings
            type: "danger",
            z_index: 9999,
          }
        );
        return;
      }

      if (Object.keys(this.changedData).length) {
        axios(send).then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "처리할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "처리되었습니다",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );

            bootstrap.Modal.getInstance(
              document.getElementById("ProModal")
            ).hide();
          }
        });
        this.childum_chk = false;
        this.$refs.qg.search();
      }
    },
    nvl(str, altStr) {
      if (typeof str == "undefined" || str == null) str = altStr;
      return str;
    },
    creatingMode() {
      this.selData = {
        name: "",
        active: "",
        product: "",
        period: "",
        price: "",
        retail_margin: "",
        bookclubs: "",
        vocajoa: "",
        subject: "",
        buyPermission: "",
        memo: "",       
      };
      this.changedData = {};
      this.creating = true;
      this.childum_chk=false;
    },
    modifyMode(record) {
      this.creating = false;
      this.childum_chk=false;
      this.changedData = {};
      this.selData = {
        id: record.id,
        active: record.active,
        name: record.name,
        product: record.product,
        period: record.period,
        price: record.price,
        retail_margin: record.retail_margin,
        bookclubs: record.bookclubs,
        vocajoa: record.vocajoa,
        subject: record.subject,
        buyPermission: record.buyPermission,
        memo: record.memo,
      };
    },
  },
  data() {
    return {
      records: [],
      selBiz: [],
      creating: true,
      selData: {
        name: "",
        active: "",
        product: "",
        period: "",
        price: "",
        retail_margin: "",
        bookclubs: "",
        vocajoa: "",
        subject : "",
        buyPermission: "",
        memo: "",
      },
      changedData: {},
      searchBiz: {},
      searchKeyword: "",
      config: {
        name: "상품관리",
        req_endpoint: "/product_manage",
        default_limit: 20,
        disable_init_search: true,
        search_fields: [
          {
            id: "filter_type",
            name: "상품유형",
            type: "switch",
            filter_type: {
              ChildU: "ChildU",
              MYPATH: "MYPATH",
              ChildUM: "ChildU(M)"
            },
          },
          {
            id: "status_filter",
            name: "사용여부",
            type: "switch",
            filter_type: {
              1: "사용",
              0: "미사용",
            },
          },
          {
            id: "searchGroup",
            name: "노출그룹 검색",
            type: "text",
            placeholder: "노출그룹 검색",
          },
          {
            id: "search",
            name: "상품명 검색",
            type: "text",
            placeholder: "상품명 검색",
          },
        ],
        columns: [
          {
            id: "id",
            name: "상품코드",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "agreementType",
            name: "상품그룹",
            excel_print: (v) => {
              return v.buyPermission;
            },
          },
          {
            id: "name",
            name: "상품명",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "product",
            name: "상품유형",
            excel_print: (v) => {
              return v.product;
            },
          },

          {
            id: "period",
            name: "기간",
            excel_print: (v) => {
              return v.period;
            },
          },
          {
            id: "price",
            name: "판매가",
            excel_print: (v) => {
              return v.price || "";
            },
          },
          {
            id: "retail_margin",
            name: "판매수수료",
            excel_print: (v) => {
              return v.retail_margin || "";
            },
          },
          {
            id: "bookclubs",
            name: "북클럽",
            excel_print: (v) => {
              return v.bookclubs || "";
            },
          },
          {
            id: "vocajoa",
            name: "보카조아",
            excel_print: (v) => {
              return v.vocajoa || "";
            },
          },
          {
            id: "subject",
            name: "과목수",
            excel_print: (v) => {
              return v.subject || "";
            },
          },
          {
            id: "active",
            name: "사용여부",
            excel_print: (v) => {
              return v.active || "";
            },
          },
          {
            id: "memo",
            name: "메모",
            excel_print: (v) => {
              return v.memo || "";
            },
          },
          {
            id: "action",
            name: "관리",
          },
        ],
      },
    };
  },
};
</script>
